







































































































































import { SketchRelatedData } from '@tt4b/ttam-enums';
import { useAutoSaveSketchRelatedData } from '@tt4b/ttam-hooks';
import { trackEvent } from '@tt4b/ttam-utils';
import { defineComponent, PropType, toRefs } from '@vue/composition-api';
import DraftSavedInfo from '@tt4b/ttam-assets/src/svgs/draft-saved-info.svg';

const name = 'ttam-auto-save-status-popover';
export default defineComponent({
  name,
  components: { DraftSavedInfo },
  props: {
    visible: { type: Boolean, default: false },
    campaignSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    adgroupSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
    creativeSketchRelatedData: {
      type: Object as PropType<SketchRelatedData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignSketchRelatedData, adgroupSketchRelatedData, creativeSketchRelatedData } = toRefs(props);

    const {
      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      isSketchSaved,
      isSketchSaving,
      isSketchSaveError,
      isSketchReachLimit,
      isSketchPublished,
      isSketchDeleted,
      lastAutoSaveTime,
      isHasDraftId,
      getCodeAndMsg,
    } = useAutoSaveSketchRelatedData({
      campaignSketchRelatedData,
      adgroupSketchRelatedData,
      creativeSketchRelatedData,
    });

    const handleReachLimitRetry = () => {
      emit('retry', false);
    };

    const handleCommonErrorRetry = () => {
      // true 表示为 common error
      emit('retry', true);
      const { code, msg } = getCodeAndMsg();
      if (isHasDraftId.value) {
        trackEvent('ttam_creation_draft_saved_xxx_ago_tryagain', {
          is_success: isSketchSaved.value,
          code,
          msg,
        });
      } else {
        trackEvent('ttam_creation_no_draft_saved_tryagain', {
          is_success: isSketchSaved.value,
          code,
          msg,
        });
      }
    };

    const handleManageDraft = () => {
      emit('manage-draft');
    };

    return {
      name,
      isSketchSaved,
      isSketchSaving,
      isSketchSaveError,
      isSketchReachLimit,
      isSketchPublished,
      isSketchDeleted,
      isHasDraftId,
      lastAutoSaveTime,

      isCampaignSketchReachLimitError,
      isAdgroupSketchReachLimitError,
      isCreativeSketchReachLimitError,
      handleCommonErrorRetry,
      handleReachLimitRetry,
      handleManageDraft,
    };
  },
});
